export interface HotboxCard {
  title: string;
  description: string;
  href: string;
}

export interface HotboxCtaStripConfig {
  blockId: string;
  cards: HotboxCard[];
}

/** Visual variants observed across the codebase. */
export type HotboxVariant =
  /** Production-default: peach #fce7d4 bg, 6px orange left border, used on 100+ raw CMS pages.
   * Computed from https://www.getscw.com/support/faq/bitrate at 1440 viewport. */
  | 'orange'
  /** Light gray bg with hover orange transform (`/decoding/rtsp`). */
  | 'light-gray'
  /** CSS-variable accent bar (`/installing-larger-systems`). */
  | 'left-border';

/** Default cards rendered when a page does not provide its own. The text is identical
 * to the 3-card hotbox embedded in Magento's "hotboxes-text" section, used on 118 raw pages. */
export const STANDARD_HOTBOX: HotboxCtaStripConfig = {
  blockId: 'cms.hotbox',
  cards: [
    {
      title: 'Get a Quote',
      description:
        "Our solutions range in pricing to fit all budgets. No matter your needs, we've got the solution.",
      href: '/get-a-quote',
    },
    {
      title: 'Request a Floorplan',
      description: "We're happy to create a custom floor plan just for you.",
      href: '/how-to-secure',
    },
    {
      title: 'Get Support',
      description: 'Our support hours are from 9 AM - 7 PM, Monday - Friday (EST).',
      href: '/support',
    },
  ],
};

/**
 * Alternate 3rd-card variant observed in production on lead-gen / educational
 * KB pages (e.g. `/knowledge-base/ethics-of-cameras-in-the-workplace`,
 * `/knowledge-base/how-long-do-security-cameras-keep-footage`). Identical first
 * two cards as `STANDARD_HOTBOX`; the third card swaps "Get Support" for the
 * "Professional installation services" upsell linking to `/installation-offices`.
 *
 * Promoted from inline route-local literals in commit `4f0ffc8` and pilot 2's
 * page-content per plan v5 §0.3 #5.
 */
export const INSTALL_SERVICES_HOTBOX: HotboxCtaStripConfig = {
  blockId: 'cms.hotbox.install-services',
  cards: [
    {
      title: 'Get a Quote',
      description:
        "Our solutions range in pricing to fit all budgets. No matter your needs, we've got the solution.",
      href: '/get-a-quote',
    },
    {
      title: 'Request a Floorplan',
      description: "We're happy to create a custom floor plan just for you.",
      href: '/how-to-secure',
    },
    {
      title: 'Professional installation services',
      description:
        'SCW offers a full suite of integrated security solutions and services backed by unmatched support for today’s business needs.',
      href: '/installation-offices',
    },
  ],
};
